import { render } from "./DebugWindow.vue?vue&type=template&id=ca544048&scoped=true&bindings={}"
import script from "./DebugWindow.vue?vue&type=script&lang=js"
export * from "./DebugWindow.vue?vue&type=script&lang=js"

import "./DebugWindow.vue?vue&type=style&index=0&id=ca544048&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca544048"

export default script